exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".com-dimensional-list[data-v-4224e9d3]{padding:16px 18px;border:1px solid #E9E9E9;background:#FFFFFF;border-radius:4px}.com-dimensional-list__header[data-v-4224e9d3]{font-size:14px;font-weight:500;color:#262626;line-height:22px}\n", ""]);

